module.exports = __webpack_public_path__ + "img/program-tour.94577f14.jpg";